import { useForm } from 'react-hook-form'
import { Input } from '@/components/common/Input'
import { Button } from '@/components/common/Button'

interface InstanceFormData {
  name: string
  webhook_url?: string
}

interface InstanceFormProps {
  onSubmit: (data: InstanceFormData) => Promise<void>
  onCancel?: () => void
  isLoading?: boolean
}

export function InstanceForm({
  onSubmit,
  onCancel,
  isLoading = false,
}: InstanceFormProps) {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<InstanceFormData>()

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-4">
      <Input
        label="Nome da Instância"
        placeholder="Ex: Suporte WhatsApp"
        error={errors.name?.message}
        {...register('name', {
          required: 'Nome é obrigatório',
          minLength: {
            value: 2,
            message: 'Nome deve ter pelo menos 2 caracteres',
          },
          maxLength: {
            value: 50,
            message: 'Nome deve ter no máximo 50 caracteres',
          },
        })}
      />

      <Input
        label="URL do Webhook (opcional)"
        placeholder="https://seu-site.com/webhook"
        type="url"
        error={errors.webhook_url?.message}
        {...register('webhook_url', {
          pattern: {
            value: /^https?:\/\/.+/,
            message: 'URL deve começar com http:// ou https://',
          },
        })}
      />

      <div className="flex gap-3 pt-2">
        {onCancel && (
          <Button
            type="button"
            variant="outline"
            fullWidth
            onClick={onCancel}
          >
            Cancelar
          </Button>
        )}
        <Button type="submit" fullWidth loading={isLoading}>
          Criar Instância
        </Button>
      </div>
    </form>
  )
}
